<!-- eslint-disable vue/multi-word-component-names -->
<template>
	<div class="loader">
		<svg ref="logo" class="logo" width="81" height="14" viewBox="0 0 81 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_296_412)">
				<path d="M5.65744 0.230957L0.115234 13.7443H3.40217L4.44789 11.0077H9.91427L10.959 13.7443H14.246L8.70472 0.230957H5.65744ZM5.45148 8.36646L7.18155 3.55408L8.91161 8.36646H5.45148Z" fill="white"/>
				<path d="M25.2069 5.78018C24.4214 5.59047 21.4518 5.2862 21.142 5.23304C20.3022 5.08916 19.851 4.80597 19.851 3.98206C19.851 3.15816 20.9444 2.56887 22.5088 2.56887C23.9252 2.56887 24.6967 2.93179 25.0374 3.91791C25.0402 3.92707 25.043 3.93624 25.0458 3.94632H28.2064C27.8394 1.76879 26.0522 0.000915527 22.4507 0.000915527C18.6049 0.000915527 16.7166 2.11246 16.7166 4.22584C16.7166 7.00092 18.677 7.82207 20.4361 8.14742C21.0072 8.25281 23.5161 8.52684 23.8737 8.58458C24.9223 8.75137 25.3033 9.04373 25.3033 9.91896C25.3033 10.8666 24.0572 11.3771 22.6361 11.3771C20.2788 11.3771 19.5832 10.4395 19.5832 8.97774H16.3843C16.637 11.586 17.9393 14.0009 22.6361 14.0009C26.422 14.0009 28.4039 12.1341 28.4039 9.53771C28.4039 7.80374 27.5183 6.26957 25.2069 5.78109V5.78018Z" fill="white"/>
				<path d="M45.4545 10.1967L42.2874 0.755178H39.3188L36.1526 10.1967L34.5218 0.230957H31.5288L33.6568 13.7443H37.6889C37.6889 13.7443 39.9179 6.98534 40.8036 4.5402C41.6892 6.98443 43.9183 13.7443 43.9183 13.7443H47.9504L50.0774 0.230957H47.0844L45.4545 10.1967Z" fill="white"/>
				<path d="M57.008 0.230957L51.4658 13.7452H54.7528L55.7975 11.0086H61.2639L62.3087 13.7452H65.5956L60.0553 0.230957H57.009H57.008ZM56.8021 8.36646L58.5321 3.55408L60.2622 8.36646H56.8021Z" fill="white"/>
				
				<path d="M77.9794 0.230957V9.69443C77.9148 9.5817 77.8502 9.46989 77.7847 9.36083L71.9794 0.230957H68.1672V13.7443H71.09V4.1672C71.1583 4.28725 71.2286 4.40914 71.3016 4.54112L77.1059 13.7443H80.8844V0.230957H77.9794Z" fill="white"/>
			</g>
			<defs>
			<clipPath id="clip0_296_412">
			<rect width="80.7692" height="14" fill="white" transform="translate(0.115234)"/>
			</clipPath>
			</defs>
		</svg>
		<!-- <div class="lottie" ref="bodymovin"></div> -->
		<button class="enterBtn" :class="{show: showEnterButton}" @click="loaderLeave">ENTER</button>
	</div>
</template>
<script>
import { E, qsa } from '@/assets/js/utils'
import store from '@/assets/js/store'
// import { Lottie } from '@lottiefiles/lottie-js';
import anim from '@/assets/anim/forusbyus'
// import lottie from 'lottie-web'
import gsap from 'gsap'
export default {
  name: 'Loader-comp',
  components: {},
  props: {
    data: Object
  },
  data () {
    return {
		anim: anim,
		showEnterButton: false
	}
  },
  created () {
  },
  mounted () {
	this.chars = qsa('path', this.$el)
	
	// const titleSize = store.isMobile ? 1 : 0.65
	// this.$refs.title.style.fontSize = store.window.w * titleSize / 5 + 'px'
	// if(store.isMobile){
	// 	const titleScale = store.window.w / this.$refs.title.getBoundingClientRect().width
	// 	this.$refs.title.style.transform = `scale(${titleScale})`
	// }
	// this.anim =  lottie.loadAnimation({
	// 	container: this.$refs.bodymovin, // Required
	// 	path:'../anim/forusbyus.json', // Required
	// 	renderer: 'svg', // Required
	// 	loop: false, // Optional
	// 	autoplay: false, // Optional
	// 	name: "Hello World", // Name for future reference. Optional.
	// 	})
	
	E.on('AssetsProgress', (e) => {
		this.chars.forEach((el, i) =>{
			i/this.chars.length
			if(e.percent * 0.1 > i/this.chars.length) {
				el.style.transitionDelay = i * 0.2 + 's'
				el.style.opacity = 1
			}
		})
	})
	E.on('PageLoaded', () => {
		// console.log(store.isLowPower)
		if(store.isLowPower) {
			this.showEnterButton = true
		} else {
			setTimeout(() => {
				this.loaderLeave()
			}, 1000)
		}
		// setTimeout(() => {
		// 	this.loaderLeave()
		// }, 1000)
		// this.anim.play()
		// this.anim.addEventListener('complete', () => {
		// 	if(store.isLowPower) {
		// 		this.showEnterButton = true
		// 	} else {
		// 		this.loaderLeave()
		// 	}
		// })
		
	})
  },
  methods: {
	spanify(text){
		const chars = text.split('')
		let out = ''
		chars.forEach(el => {
			out += '<span class="char">'
			out += el
			out += '</span>'	
		})
		return out
	},
	loaderLeave(){
		document.querySelectorAll('video')[0].play()
		this.showEnterButton = false
		this.chars.forEach((el) =>{
				el.style.transitionDelay = 0 + 's'
			})
			gsap.to(this.chars, { opacity: 0, stagger: 0.1, duration: 0.01,
				onComplete: () => {
					gsap.to(this.$refs.bodymovin, { opacity: 0., duration: 0.3, 
						onComplete: () => {
							this.$el.classList.add('leave')
							store.loaderIsOut = true
							E.emit('LoaderOut')
						}
					})
				} 
			})
	}
  }
}
</script>
<style lang="less">
	@import '../../assets/less/_imports.less';
	@import "./style.less";
</style>